<div class="order-details" fxLayout="column" fxFlex="100" fxLayoutAlign="start start">
    <div>
        <span class="breadcrumb" (click)="navigateToOrders()">All Orders</span><span class="breadcrumbdark"> /
            {{getInvoiceNo(order?.orderNumber)}}</span>
    </div>
    <div class="order-details__header width_100" fxLayoutAlign="space-between center">
        <div fxLayout="row">
            <div class="order-details__header-status" [ngClass]="order?.payment">
                {{getPaymentStatus(order?.payment,order?.status)}}
            </div>
            <div class="order-details__header-status"
                *ngIf="order?.cancellationReason!=''&&order?.cancellationReason!=null &&order?.status == 'cancelled'"
                class="cancellationReason">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" style="margin-right:5px;" width="12" height="12"
                        viewBox="0 0 12 12">
                        <g id="info" transform="translate(-2.239 -2.244)">
                            <path id="Path_5377" data-name="Path 5377"
                                d="M8.827,2.273a6.006,6.006,0,0,1,4.047,9.78,6,6,0,1,1-4.047-9.78Zm.411,11.014a5.114,5.114,0,1,0-3.41-.5,5.137,5.137,0,0,0,3.41.5ZM7.789,6.532H8.877V5.675H7.789Zm1.088.857v3.429H7.789V7.39Z"
                                transform="translate(0 0)" fill="#d9480f" fill-rule="evenodd" />
                        </g>
                    </svg>
                </span>
                {{showCancellation(order?.cancellationReason)}}
            </div>
        </div>
        <div class="order-details__header-download" fxLayoutAlign="center center">
            <!-- <mat-icon [svgIcon]="'download-outline'"></mat-icon> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"
                style="margin-right: 5px;">
                <path id="download-outline"
                    d="M16.071,6.382v5.647h1.254L15,14.072l-2.325-2.042h1.254V6.382h2.143M18.214,4.5H11.786v5.647H7.5L15,16.735l7.5-6.588H18.214V4.5M22.5,18.618H7.5V20.5h15Z"
                    transform="translate(-7.5 -4.5)" fill="#868E96" />
            </svg>
            Download invoice
        </div>
    </div>
    <form [formGroup]="orderDetailsForm" *ngIf="orderDetailsForm" class="order-details__main" fxLayout="column"
        fxLayoutGap="20px" fxLayoutAlign="center start">
        <!-- <div class="order-details__main-edit cursor_pointer"
             fxLayoutAlign="start center"
             [class.order-details__main-edit-disabled]="order?.status === 'cancelled' || order?.status === 'delivered'"
             [class.desktop]="!globalService.isMobile"
             (click)="editOrder()">
            Edit Order
        </div> -->

        <div class="order-details__main-info width_100" fxLayout="column">
            <div class="order-details__main-info-row width_100" fxLayoutAlign="start center">
                <div class="order-details__main-info-label" fxFlex="{{globalService.isMobile$.getValue() ? 35 : 10}}">
                    Transaction Status</div>

                <div class="order-details__main-info-select active" fxLayout="row" fxLayoutAlign="space-between center"
                    [matMenuTriggerFor]="menu" #t="matMenuTrigger"
                    [ngClass]="order?.status !='cancelled'?order?.status:'greyedOut'">
                    <div *ngIf="order?.status === 'open'">New Request</div>
                    <div *ngIf="order?.status === 'completed'">Completed</div>
                    <div *ngIf="order?.status === 'confirmed'">Confirmed</div>
                    <div *ngIf="order?.status === 'noShow'">No Show</div>
                    <div *ngIf="order?.status === 'cancelled'">
                        Cancelled</div>
                    <mat-icon [class.rotated]="t.menuOpen" [svgIcon]="'arrow-down'"></mat-icon>
                </div>

                <mat-menu #menu="matMenu" class="order-details-status" yPosition="below">
                    <div class="menu-option" (click)="changeStatus(item)"
                        *ngFor="let item of statusOptions; let i = index">
                        <hr *ngIf="item.name === 'Cancelled'" class="separator">
                        <div class="order-details__main-info-select" fxLayout="row" fxLayoutAlign="space-between center"
                            [ngClass]="
  (order?.status === 'confirmed' && item.code === 'open') || (order?.status === 'noShow' && item.code === 'open')
    ? 'disabled'
    : (order?.status != 'cancelled' && order?.status != 'completed'
        ? item.code
        : 'disabled')
">
                            <div *ngIf="item.name != 'Cancelled'">{{item.name}}</div>
                            <div *ngIf="item.name == 'Cancelled'">Cancel Appointment</div>
                        </div>
                    </div>
                </mat-menu>
            </div>
            <button class="viewDetails" (click)="onEditEvent()">Edit Appointment</button>

            <div class="order-details__main-info-row width_100" fxLayoutAlign="start center">
                <div class="order-details__main-info-label" fxFlex="{{globalService.isMobile$.getValue() ? 35 : 10}}">
                    Invoice No.</div>

                <div class="order-details__main-info-value">{{order?.invoiceNumber}}</div>
            </div>

            <div class="order-details__main-info-row width_100" fxLayoutAlign="start center">
                <div class="order-details__main-info-label" fxFlex="{{globalService.isMobile$.getValue() ? 35 : 10}}">
                    Appointment Date</div>

                <div class="order-details__main-info-value">{{order?.bookingDate}}</div>
            </div>

            <div class="order-details__main-info-row width_100" fxLayoutAlign="start center">
                <div class="order-details__main-info-label" style="color: #D9480F;"
                    fxFlex="{{globalService.isMobile$.getValue() ? 35 : 10}}">
                    Amount Due</div>

                <div class="order-details__main-info-value" style="color: #D9480F;">{{
                    order?.amountPaid?(order?.amountDue| number:'1.2-2'):(toNumber(order?.totalAmount) | number:'1.2-2')
                    || (toNumber(order?.price) | number:'1.2-2')}} {{globalService.currency}}</div>
            </div>

            <div class="order-details__main-info-row width_100" fxLayoutAlign="start center">
                <div class="order-details__main-info-label" fxFlex="{{globalService.isMobile$.getValue() ? 35 : 10}}">
                    Amount Paid</div>

                <div class="order-details__main-info-value">{{order?.amountPaid |
                    number:'1.2-2'}} {{globalService.currency}}</div>
            </div>
        </div>

        <div class="order-details__main-order width_100" fxLayout="column" fxLayoutAlign="center start">
            <div class="order-details__main-order-header width_100" fxLayoutAlign="start center">
                <div class="order-details__main-order-item title width_100">SERVICE TYPE</div>
                <div class="order-details__main-order-price title width_100">PRICE</div>
                <div class="order-details__main-order-qty title width_100">QTY</div>
                <div class="order-details__main-order-total title width_100">TOTAL</div>
            </div>
            <div class="order-details__main-order-orders width_100" fxLayoutAlign="start center">
                <div class="order-details__main-order-item width_100">{{order?.serviceType}}</div>
                <div class="order-details__main-order-price width_100">{{(toNumber(order?.totalAmount) | number:'1.2-2')
                    || (toNumber(order?.price) | number:'1.2-2')}}
                    {{globalService.currency}}</div>
                <div class="order-details__main-order-qty width_100">{{order?.quantity}}</div>
                <div class="order-details__main-order-total width_100">
                    {{ (toNumber(order?.totalAmount) | number:'1.2-2') || (toNumber(order?.price) | number:'1.2-2') }}
                    {{globalService.currency}}
                </div>
            </div>
            <div class="order-details__main-order-result pt-20 width_100" fxLayout="row-reverse">
                <div class="order-details__main-order-total width_100">
                    {{subTotal | number:'1.2-2'}} {{globalService.currency}}
                </div>
                <div class="order-details__main-order-qty title width_100">Subtotal</div>
            </div>
            <div class="order-details__main-order-result width_100" fxLayout="row-reverse">
                <div class="order-details__main-order-total width_100">
                    {{0.00 | number:'1.2-2'}} {{globalService.currency}}
                </div>
                <div class="order-details__main-order-qty title width_100">Voucher</div>
            </div>
            <div class="order-details__main-order-result total width_100" fxLayout="row-reverse">
                <div class="order-details__main-order-total width_100">
                    {{totalAmount | number:'1.2-2'}} {{globalService.currency}}
                </div>
                <div class="order-details__main-order-qty width_100">Total</div>
            </div>
        </div>

        <div class="order-details__main-note width_100" fxLayoutGap="5px" fxLayout="column" fxLayoutAlign="start start">
            <mat-label>Note/Remarks</mat-label>
            <mat-form-field class="width_100 disabled-color">
                <textarea matInput [placeholder]="order?.note==''? 'No note/remarks':''"
                    formControlName="note"></textarea>
            </mat-form-field>
        </div>
    </form>
</div>